module.exports = __webpack_public_path__ + "img/easyupdates.1f8ef27f.png";